import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Slider from 'rc-slider';

import CurrencyConverter from '../../CurrencyConverter';
import messages from '../../../locale/messages';
import {
  FEATURED_PRICE_SLIDER_MAX,
  LOWEST_PRICE_MAX_USD,
  LOWEST_PRICE_MIN_USD,
  LUXURY_PRICE_MAX_USD,
  LUXURY_PRICE_MIN_USD,
} from './featuredCarsData';
import FeaturedCarFilterIcon from './featuredCarFilterIcons';

import s from './FeaturedCars.css';
import cs from '../../commonStyle.css';
import sliderStyles from '!isomorphic-style-loader!css-loader!rc-slider/assets/index.css';

const FeaturedCarsPriceFilter = ({
  filter,
  isOpen,
  isActive,
  minPrice,
  maxPrice,
  buttonLabel,
  onToggle,
  onRangeChange,
  onApply,
  setBtnWrapperRef,
  setPopoverWrapperRef,
}) => {
  const isLuxury = filter.key === 'luxury';

  const renderPriceRangeLabel = () => {
    if (isLuxury) {
      return (
        <p className={cx(cs.commonContentText, cs.fontWeightMedium, cs.fontDMSans)}>
          <CurrencyConverter amount={minPrice} from="USD" />
          <span>{'+ '}</span>
          <FormattedMessage {...messages.perNight} />
        </p>
      );
    }

    return (
      <p className={cx(cs.commonContentText, cs.fontWeightMedium, cs.fontDMSans)}>
        <CurrencyConverter amount={minPrice} from="USD" />
        <span>{' - '}</span>
        <CurrencyConverter amount={maxPrice} from="USD" />
        <span>{'  '}</span>
        <FormattedMessage {...messages.perNight} />
      </p>
    );
  };

  return (
    <div
      className={s.filterButtonContainer}
      ref={setBtnWrapperRef}
    >
      <button
        type="button"
        className={cx(s.filterBtn, isActive && s.filterBtnActive)}
        onClick={onToggle}
      >
        <FeaturedCarFilterIcon type={filter.icon} />
        {buttonLabel}
      </button>
      {isOpen && (
        <div
          className={s.searchFilterPopover}
          ref={setPopoverWrapperRef}
        >
          <div className={s.searchFilterPopoverContent}>
            {renderPriceRangeLabel()}
            <div className={s.priceRangeContainer}>
              {isLuxury ? (
                <Slider
                  min={LUXURY_PRICE_MIN_USD}
                  max={FEATURED_PRICE_SLIDER_MAX}
                  value={minPrice}
                  onChange={(value) => onRangeChange([value, LUXURY_PRICE_MAX_USD])}
                  step={1}
                />
              ) : (
                <Slider
                  range
                  min={LOWEST_PRICE_MIN_USD}
                  max={LOWEST_PRICE_MAX_USD}
                  value={[minPrice, maxPrice]}
                  onChange={onRangeChange}
                  allowCross={false}
                  step={1}
                />
              )}
            </div>
            <div className={cx(
              s.searchFilterPopoverFooter,
              s.displayTable,
              s.popoverFooterDivider,
            )}>
              <div className={cx('text-left', s.displayTableCell)} />
              <div className={cx(s.floatRight, 'floatLeftRTL')}>
                <button
                  type="button"
                  className={s.priceFilterApplyBtn}
                  onClick={onApply}
                >
                  <FormattedMessage {...messages.apply} />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

FeaturedCarsPriceFilter.propTypes = {
  filter: PropTypes.shape({
    key: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  minPrice: PropTypes.number.isRequired,
  maxPrice: PropTypes.number.isRequired,
  buttonLabel: PropTypes.node.isRequired,
  onToggle: PropTypes.func.isRequired,
  onRangeChange: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  setBtnWrapperRef: PropTypes.func.isRequired,
  setPopoverWrapperRef: PropTypes.func.isRequired,
};

export default withStyles(s, cs, sliderStyles)(FeaturedCarsPriceFilter);
